import { Box, Fade, Grid } from "@mui/material";
import WhitoutAccessImg from "../../assets/withoutAccess/whitoutAccess.png";

export function WithoutAccess() {
  return (
    <Fade in>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Box marginTop="5vh">
          <Grid spacing={0} alignItems="center">
            <Grid item xs={6}>
              <img src={WhitoutAccessImg } alt="você não possui acesso" />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Fade>
  );
}
